import {useTranslation} from "next-i18next";
import {MenuItems} from "../../data/Menu/Navigation.config";
import Button from "./Button";
import DropdownButton from "./DropdownButton";
import {useRouter} from "next/router";

function Navigation(props: { scrolledStyle: boolean; color?: string }) {
	const {t} = useTranslation();
	const router = useRouter();
	const asPath = router.asPath;
	const pathWithoutParams = asPath.replace(/\?.*?(?=#|$)/, "");

	return (
		<nav
			className={`transition duration-300 hidden lg:block flex-grow  ${
				props.scrolledStyle
					? " border-none bg-white"
					: "border-white border-none bg-transparent"
			}`}
		>
			<div className="flex 2xl:h-8 h-8 justify-end">
				{MenuItems.map((menuItem) => {
					if (!menuItem.submenuItems) {
						const navColor = (pathWithoutParams == menuItem.url) ? "text-black" : "text-white";

						return (
							<Button
								className="min-h-full flex uppercase font-bold text-[12px]"
								key={menuItem.label}
								text={t(menuItem.label)}
								transparent={true}
								border={false}
								textColor={
									props.scrolledStyle
										? "text-leo-button-gray"
										: navColor
								}
								href={menuItem.url}
								textTransform="uppercase"
							/>
						);
					} else {
						return (
							<DropdownButton
								className="min-h-full flex font-bold text-[12px]"
								textTransform="uppercase"
								key={menuItem.label}
								textAlign="text-left"
								border={false}
								transparent={true}
								text={t(menuItem.label)}
								hoverTextColor="hover:text-leo-orange"
								href={menuItem.url}
								textColor={
									props.scrolledStyle
										? "text-leo-button-gray"
										: props.color
											? `text-[${props.color}]`
											: undefined
								}
								subMenuItems={menuItem.submenuItems.map((submenuItem) => {
									submenuItem;
									return {name: t(submenuItem.label), href: submenuItem.url};
								})}
							/>
						);
					}
				})}
			</div>
		</nav>
	);
}

export default Navigation;
